import { SyntheticEvent } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import HomeV2Model, { TAB_PATHS } from './model';

export default function HomeV2ViewModel() {
  const location = useLocation();
  const navigate = useNavigate();
  const fileCategoryMatch = useMatch('/meus-arquivos/:category');
  const examCategoryMatch = useMatch('/meus-exames/:category');

  const value = HomeV2Model.getActiveTabIndex(location.pathname);
  const showTabs = HomeV2Model.isTabsVisible(fileCategoryMatch, examCategoryMatch);

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    navigate(TAB_PATHS[newValue], { replace: true });
  };

  return {
    value,
    handleChange,
    showTabs,
    showFileCategoryPage: !!fileCategoryMatch,
    showExamCategoryPage: !!examCategoryMatch
  };
}
